import SignIn from "../../../pages/sign-in";
import SignUp from "../../../pages/sign-up";
import EmailOTP from "../../../pages/email-otp";
import Header from "../header"
import Styles from "./index.module.scss";
import ResetPassword from "../../../pages/reset-password";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ForgotPassword from "../../../pages/forgot-password";
import { useScreen } from "../../../../context/useScreen";
import { PAGE_NAME } from "../../../../utils/constant/constant";
import SocialAuthPage from "../../../pages/social-auth";

const Layout = () => {

    const { displayScreen } = useScreen()

    const noHeaderPages: string[] = [PAGE_NAME.GOOGLE, PAGE_NAME.FACEBOOK, PAGE_NAME.APPLE];
    const showHeader = !noHeaderPages.includes(displayScreen);

    const renderScreen = () => {
        // Change route to appropriate value
        switch(displayScreen) {
            case PAGE_NAME.EMAIL_OTP_SIGN_UP:
                return <EmailOTP isSignupForm={true} />;
            case PAGE_NAME.EMAIL_OTP_SIGN_IN:
                return <EmailOTP isSignupForm={false} />;
            case PAGE_NAME.FORGOT_PASSWORD:
                return <ForgotPassword />;
            case PAGE_NAME.SIGN_IN:
                return <SignIn />;
            case PAGE_NAME.SIGN_UP:
                return <SignUp />;
            case PAGE_NAME.GOOGLE:
                return <SocialAuthPage provider={PAGE_NAME.GOOGLE} />;
            case PAGE_NAME.FACEBOOK:
                return <SocialAuthPage provider={PAGE_NAME.FACEBOOK} />;
            case PAGE_NAME.APPLE:
                return <SocialAuthPage provider={PAGE_NAME.APPLE} />;
            default:
                return <SignIn />; // Default to login if screenType is undefined or doesn't match
        }
    };
    
    return <div className={Styles.layout}>
        {showHeader && <Header/>}
        <main className={Styles.main}>
            <Router>
                <Routes>
                    <Route path="/lo/reset" element={<ResetPassword />} />
                    <Route path="/login" element={renderScreen()} />
                    {/* Add more routes as needed */}
                </Routes>
            </Router>
        </main>
    </div>
}

export default Layout;